export const clickPayoutValidation = (value) => {
  const result = { valid: true, message: '' };
  if (value < 0) {
    result.valid = false;
    result.message = 'Click payout cannot be negative';
  }
  if (value > 999.99) {
    result.valid = false;
    result.message = 'Click payout cannot exceed $999.99';
  }
  return result;
};
